<div class="dialog">
  <div class="dialog-header">
    <span class="dialog-title">
      Assigned rooms — Booking #{{ data.bookingId }}
    </span>

    <button type="button" class="close-btn" [disabled]="isLoading" (click)="close()" aria-label="Close">
      ×
    </button>
  </div>

  <span class="dialog-subtitle">
    Family code {{ data.familyCode || '-' }}
  </span>

  @if(!hasLoaded) {
  <div class="muted">Loading assigned rooms…</div>
  } @else if(assignedGroups.length === 0) {
  <div class="muted">
    No rooms assigned{{ data.canRelease ? ' — the booking returns to Pending.' : '.' }}
  </div>
  } @else {
  <div class="property-groups">
    @for(group of assignedGroups; track group.propertyId) {
    <div class="property-group">
      <span class="property-name">
        {{ group.propertyName }}
      </span>

      @for(room of group.rooms; track room.roomId) {
      <div class="room-line">
        <span class="room-info">
          Room {{ room.roomNumber }} · {{ room.roomType }} ·
          Beds {{ room.beds.length }}/{{ room.capacity }}
          ({{ room.beds.join(', ') }})
        </span>

        @if(data.canRelease) {
        <button type="button" class="ac-secondary-small-btn" [disabled]="isLoading" (click)="release(room.roomId)">
          Release
        </button>
        }
      </div>
      }
    </div>
    }
  </div>
  }

  <!-- <div class="dialog-actions">
    <button
      type="button"
      class="ac-secondary-btn"
      [disabled]="isLoading"
      (click)="close()"
    >
      Close
    </button>
  </div> -->
</div>

<app-loader [isLoading]="isLoading"></app-loader>